import { Menu } from "@mui/material"
import React from "react"

type OuterMenuWrapperType = {
    anchorEl: HTMLElement | null;
    open: boolean;
    height: number;
    handleClose: () => void;
    children: React.ReactNode;
}

export const OuterMenuWrapper: React.FC<OuterMenuWrapperType> = ({
    anchorEl,
    open,
    height,
    handleClose,
    children
}) => {
    return (
        <Menu
            id="long-menu"
            style={{
                top: "10px",
            }}
            MenuListProps={{
            'aria-labelledby': 'long-button',
                style: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            }}
            anchorEl={anchorEl}
            open={open}
            PaperProps={{
            style: {
                    width: "233px",
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    paddingBottom: 0,
                },
            }}
            
            onClose={handleClose}
        >
            {children}
        </Menu>
    )
}